app.directive('formNumberInput', [
  '$timeout',
  function ($timeout) {
    return {
      restrict: 'E',
      scope: {
        itemId: '@',
        label: '@',
        min: '@',
        max: '@',
        isRequired: '@',
      },
      require: ['^form'],
      templateUrl: '/themes/v1/default/views/form.number-input.html',
      link: function ($scope) {
        var min = $scope.min.length ? parseInt($scope.min, 10) : undefined;
        var max = $scope.max.length ? parseInt($scope.max, 10) : undefined;

        var shouldLimitBtnDisabled = function (number) {
          if (number === undefined) return true;
          if (number.length === 0) return true;
        };
        var shouldeMinBtnDisabled = function (number, min) {
          return (
            shouldLimitBtnDisabled(number) ||
            (min !== undefined && number <= min)
          );
        };
        var shouldeMaxBtnDisabled = function (number, max) {
          return (
            shouldLimitBtnDisabled(number) ||
            (max !== undefined && number >= max)
          );
        };

        $scope.isMinusDisabled = shouldeMinBtnDisabled($scope.number, min);
        $scope.isPlusDisabled = shouldeMaxBtnDisabled($scope.number, max);

        var debouncePromise;
        $scope.onChange = function () {
          var value = event.target.value;
          if (debouncePromise) $timeout.cancel(debouncePromise);
          debouncePromise = $timeout(function () {
            $scope.number = rectify(value, min, max);
          }, 450);
        };

        $scope.decrease = function () {
          $scope.number = rectify($scope.number - 1, min, max);
        };

        $scope.increase = function () {
          $scope.number = rectify($scope.number + 1, min, max);
        };

        $scope.$watch('number', function (next) {
          $scope.isMinusDisabled = shouldeMinBtnDisabled(next, min);
          $scope.isPlusDisabled = shouldeMaxBtnDisabled(next, max);
        });

        var rectify = function (value, min, max) {
          if (value) {
            if (typeof value === 'string') {
              // product assumes number input is integer for simplicity for now
              value = value.replace(/\D/g, '');
              value = parseInt(value, 10);
            }
            if (min !== undefined && value < min) return min;
            if (max !== undefined && value > max) return max;
          }
          return value;
        };
      },
    };
  },
]);
